import React from "react"
import PatientMoreDetail from "../components/Patient/PatientMoreDetail"

const PatientMoreDetailView = () => <PatientMoreDetail />

export default PatientMoreDetailView
